/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from "react";
import {
    Modal, Input, message, notification, Progress
} from "antd";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import OneIntelligenceServices from "../../../../services/OneIntelligence.services";
import { setPassword } from "../../../../store/components/DashboardReport.slice";
import { setBuildTargetFromLoadedJson } from "../../../../store/components/BuildTargets.slice";
import { setMarketExplorerFromLoadedJson } from "../../../../store/components/MarketExplorer.slice";
import { setReportBuilderFromLoadedJson } from "../../../../store/components/ReportBuilder.slice";
import { setReportsFromLoadedJson } from "../../../../store/components/Reports.slice";

function InputPasswordModal({
    visible,
    onClose = () => {}
}) {
    const routeParams = useParams();
    const dispatch = useDispatch();
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [percentage, setPercentage] = useState(0);

    return (
        <Modal
            className="report--freeformmodal"
            open={visible}
            closable={false}
            maskClosable={false}
            title="Enter Password"
            okText={isLoading ? "Retrieving Data..." : "Submit"}
            cancelButtonProps={{
                style: { display: "none" }
            }}
            okButtonProps={{
                loading: isLoading
            }}
            onCancel={() => {
                onClose(false);
            }}
            onOk={() => {
                if (!confirmPassword) {
                    message.warning("Please input password.");
                    return;
                }
                setIsLoading(true);
                const fProgress = ({ loaded, total }) => {
                    setPercentage((loaded / total) * 100);
                };
                OneIntelligenceServices.getPublishedDashboard(confirmPassword, routeParams, fProgress).then((resp) => {
                    if (resp) {
                        setIsLoading(false);
                        dispatch(setPassword(confirmPassword));
                        const {
                            data: {
                                buildTargets, reportBuilder, marketExplorer, reports,
                            }, timestamp, ownerInformation, name
                        } = resp;
                        // window.sq.app.oneintel.isLoadedAnalysis = true;
                        dispatch(setBuildTargetFromLoadedJson(buildTargets));
                        dispatch(setMarketExplorerFromLoadedJson(marketExplorer));
                        dispatch(setReportBuilderFromLoadedJson(reportBuilder));
                        dispatch(setReportsFromLoadedJson(reports));
                        notification.success({
                            message: "OneIntelligence Viewer",
                            description:
                            `${name} dashboard successfully loaded. File Timestamp: ${new Date(timestamp).toISOString()}`
                        });
                        onClose(false);
                    }
                    setPercentage(0);
                });
            }}
        >
            <div className="d-flex-col justify-content-center gap-1">
                <span>Password: </span>
                <Input
                    type="password"
                    placeholder="Please input password."
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
            </div>
            {percentage > 0 ? <Progress percent={parseInt(percentage, 10)} status="active" /> : null}
        </Modal>
    );
}

export default InputPasswordModal;
